// builder/adapter that produces that DTO from UI state.
//  pure mapper. Its job is to assemble whatever fields the API expects, no more / no less.
import { Filter } from '../../../public-filters/domain/valueObjects/Filter';
import { BoundingBox } from '../../domain/valueObjects/BoundingBox';
import { PropertySearchRequest } from '../../domain/valueObjects/PropertySearchRequest';
import { toApiFilter } from './toApiFilter';

/*
{
  "bounds": { "swLat": 29.1, "swLng": -98.6, "neLat": 29.7, "neLng": -98.1 },
  "polygon": { "type": "Polygon", "coordinates": [[[...]]] },
  "filters": {
    "status": ["Active", "Pending"],
    "price": { "min": 250000, "max": 750000 },
    "beds": { "min": 3 },
    "baths": { "min": 2 },
    "homeTypes": ["Single Family Residential"]
  },
  "resultType": "markers",   // or "properties"
  "page": 1,
  "perPage": 20
}

*/
// Create a single hook that knows how to build the API payload:
export function buildPropertySearchRequest({
  bounds,
  polygon,
  filter,
  page,
  perPage,
  resultType,
  listSortId,
}: {
    bounds?: BoundingBox;
    polygon?: GeoJSON.Feature[];
    filter?: Filter;
    page?: number;
    perPage?: number;
    resultType: 'markers' | 'properties';
    listSortId?: string;
  }): PropertySearchRequest {
  const polygons = polygon
    ?.filter((f) => f.geometry.type === 'Polygon')  // only take polygons
    .map((f) => f.geometry as GeoJSON.Polygon);

  return {
    bounds,
    polygon: polygons && polygons.length > 0 ? polygons : undefined,
    filters: toApiFilter(filter),
    page,
    perPage,
    resultType,
    listSortId,
  };
}
